const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P0.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p0_w.path.beauty.linkName',
        title: 'p0_w.path.beauty.title',
        info: 'p0_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0_Beauty.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.beauty.description.title',
          content: 'p0_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_w.path.selfCheckout.linkName',
        title: 'p0_w.path.selfCheckout.title',
        info: 'p0_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P0_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.selfCheckout.description.title',
          content: 'p0_w.path.selfCheckout.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p1_w.path.lingerie.linkName',
        title: 'p1_w.path.lingerie.title',
        info: 'p1_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Lenceria.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.lingerie.description.title',
          content: 'p1_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p1_w.path.shoes.linkName',
        title: 'p1_w.path.shoes.title',
        info: 'p1_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Calzado_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Calzado.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.shoes.description.title',
          content: 'p1_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p1_w.path.onlinePickup.linkName',
        title: 'p1_w.path.onlinePickup.title',
        info: 'p1_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_PuntoRecogidaOnline.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.onlinePickup.description.title',
          content: 'p1_w.path.onlinePickup.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p1_w.path.pickup.linkName',
        title: 'p1_w.path.pickup.title',
        info: 'p1_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_RecogidaRopa_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P1_ReciclajeRopa.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.pickup.description.title',
          content: 'p1_w.path.pickup.description.content',
        },
      },
    ],
  },
  p2_w: {
    sectionPath: '/floor_2',
    locationKey: 'p2_w',
    sectionKey: 'WOMAN',
    floorKey: '2',
    section: 'p2_w.section.name',
    floor: 'p2_w.floor.name',
    title: 'Título de la Planta 2',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P2.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_P2.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_w.path.floorMap.linkName',
        title: 'p2_w.path.floorMap.title',
        info: 'p2_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.floorMap.description.title',
          content: 'p2_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p2_w.path.fittingRooms.linkName',
        title: 'p2_w.path.fittingRooms.title',
        info: 'p2_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_TurnoProbadores.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.fittingRooms.description.title',
          content: 'p2_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p2_w.path.selfCheckout.linkName',
        title: 'p2_w.path.selfCheckout.title',
        info: 'p2_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.selfCheckout.description.title',
          content: 'p2_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/refunds',
        exact: true,
        location: 'refunds',
        linkName: 'p2_w.path.refunds.linkName',
        title: 'p2_w.path.refunds.title',
        info: 'p2_w.path.refunds.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_Devoluciones_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_Devoluciones.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.refunds.description.title',
          content: 'p2_w.path.refunds.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/onlineReturn',
        exact: true,
        location: 'onlineReturn',
        linkName: 'p2_w.path.onlineReturn.linkName',
        title: 'p2_w.path.onlineReturn.title',
        info: 'p2_w.path.onlineReturn.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_DevolucionesOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_P2_DevolucionesOnline.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_w.path.onlineReturn.description.title',
          content: 'p2_w.path.onlineReturn.description.content',
        },
      },
    ],
  },
  s1_k: {
    sectionPath: '/floor_-1',
    locationKey: 's1_k',
    sectionKey: 'MAN',
    floorKey: '-1',
    section: 's1_k.section.name',
    floor: 's1_k.floor.name',
    title: 'Título del Sótano',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/3/p/2224/766/800/303/w/649/2224766800_15_1_1.jpg?ts=1642521515572',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_S1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/16231_S1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_-1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 's1_k.path.floorMap.linkName',
        title: 's1_k.path.floorMap.title',
        info: 's1_k.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_k.path.floorMap.description.title',
          content: 's1_k.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 's1_k.path.selfCheckout.linkName',
        title: 's1_k.path.selfCheckout.title',
        info: 's1_k.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1_Autocobro.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_k.path.selfCheckout.description.title',
          content: 's1_k.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_-1',
        path: '/pickUpSize',
        exact: true,
        location: 'pickUpSize',
        linkName: 's1_k.path.pickUpSize.linkName',
        title: 's1_k.path.pickUpSize.title',
        info: 's1_k.path.pickUpSize.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1_EncuentraTalla_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/16231_S1_EncuentraTalla.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 's1_k.path.pickUpSize.description.title',
          content: 's1_k.path.pickUpSize.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'es-ES',
    name: 'Español',
  },
  {
    language: 'gl-ES',
    name: 'Galego',
  },
  {
    language: 'eu-ES',
    name: 'Euskara',
  },
  {
    language: 'ca-ES',
    name: 'Català',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/16231_DUQUE_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
